var map = {
	"./Bifrost-logo.png": 3909,
	"./ECV_logo.png": 3252,
	"./Error404.png": 1950,
	"./autumn/6689.png": 5302,
	"./autumn/autumnCloudManCake.png": 5668,
	"./autumn/leaf-1.png": 1165,
	"./autumn/leaf-2.png": 486,
	"./autumn/leaf-3.png": 8575,
	"./autumn/leaf-4.png": 9920,
	"./autumn/leaf-5.png": 4745,
	"./birthday_hat.png": 8653,
	"./eye.png": 4353,
	"./login-bg-origin.png": 2974,
	"./login-bg.png": 4533,
	"./logo-white.png": 8237,
	"./logo/ga.png": 7966,
	"./logo/hg.png": 2173,
	"./logo/hr.png": 3392,
	"./logo/on.png": 8817,
	"./spring/spring-bg-1.png": 3921,
	"./spring/spring-deer.png": 934,
	"./summer/Bifrost-logo-white.png": 9709,
	"./summer/beachGirl.png": 3461,
	"./summer/seaBG.png": 5006,
	"./summer/seaTurtle.png": 7633,
	"./winter/Christmas_Hat-_back2.png": 3359,
	"./winter/Christmas_Hat.png": 4176,
	"./winter/Christmas_Hat_bak.png": 7627,
	"./winter/Christmas_Hat_rabbion.png": 3630,
	"./winter/snow-man.png": 334,
	"./winter/tree-icon.png": 768,
	"./winter/winter-footer-tree.png": 8906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;